<script setup lang="ts">
import type { Sector } from "~/modules/sector/models/Sector.interface";
import { getProfileLabel } from "~/modules/user/utils/profileLabel";
import { SectorResource } from "~/types";

const { t } = useI18n();

defineProps<{
  sector: Sector;
}>();
const emits = defineEmits(["change"]);

function onChange() {
  emits("change");
}
</script>
<template>
  <sector-toolbar
    ref="sectorToolbar"
    primary-key="login"
    :sector="sector"
    :resource="SectorResource.USER"
    @change="onChange"
  >
    <lxc-table-column prop="lastName" :label="t('table.header.lastname')" />
    <lxc-table-column prop="firstName" :label="t('table.header.firstname')" />
    <lxc-table-column :label="t('table.header.profile')" width="12rem">
      <template #default="scope">
        <badge-for-list
          :label="getProfileLabel(scope.row.profile)"
          type="secondary"
        />
      </template>
    </lxc-table-column>
  </sector-toolbar>
</template>
